export default __webpack_public_path__ + "static/media/trash.6357a064.svg";